/**
 * 按钮的具体类型参考 https://www.naiveui.com/zh-CN/os-theme/components/button
 * 此组件只是将按钮颜色调整为默认#172344
 */

export const buttonProps = {
  /**
   * 文字颜色
   * 按钮颜色（支持形如 #FFF， #FFFFFF， yellow，rgb(0, 0, 0) 的颜色）
   */
  color: { type: String as PropType<string>, default: '#172344' },
  'text-color': { type: String as PropType<string>, default: '#fff' },
  /**
   * 按钮是否显示加载状态
   */
  loading: { type: Boolean },
  /**
   * 是否禁用
   */
  disabled: { type: Boolean },
  /**
   * 按钮中图标的位置
   */
  'icon-placement': { type: String as PropType<'left' | 'right'>, default: 'left' },
  /**
   * 按钮尺寸 按钮的尺寸
   */
  size: { type: String as PropType<'tiny' | 'small' | 'medium' | 'large'>, default: 'medium' },
  /**
   * 按钮的类型
   */
  type: {
    type: String as PropType<
      'default' | 'tertiary' | 'primary' | 'success' | 'info' | 'warning' | 'error'
    >,
    default: 'default',
  },
  /**
   * 按钮使用什么标签渲染
   */
  tag: { type: String as PropType<keyof HTMLElementTagNameMap>, default: 'button' },
  onClick: { type: Function as PropType<(...args) => any>, default: null },
};
